// 対数スケールの変換関数
export function toLogScale(value: number, min: number, max: number): number {
  if (value <= 0) return 0;
  const minLog = Math.log(min);
  const maxLog = Math.log(max);
  const scale = (Math.log(value) - minLog) / (maxLog - minLog);
  // 0-5%の範囲を0として扱う
  return Math.round(scale * 95) + 5;
}

// 対数スケールから実際の値への変換関数
export function fromLogScale(scale: number, min: number, max: number): number {
  // 0-5%の範囲を0として扱う
  if (scale <= 5) return 0;
  const minLog = Math.log(min);
  const maxLog = Math.log(max);
  // スケールを0-100%に正規化
  const normalizedScale = (scale - 5) / 95;
  const value = Math.exp(minLog + normalizedScale * (maxLog - minLog));
  return value;
}

// 値を適切な単位で丸める関数
export function roundToNiceNumber(value: number): number {
  if (value <= 0) return 0;
  if (value < 10000) {
    // 1,000円単位
    return Math.round(value / 1000) * 1000;
  } else if (value < 100000) {
    // 5,000円単位
    return Math.round(value / 5000) * 5000;
  } else if (value < 1000000) {
    // 1万円単位
    return Math.round(value / 10000) * 10000;
  } else if (value < 10000000) {
    // 10万円単位
    return Math.round(value / 100000) * 100000;
  } else {
    // 100万円単位
    return Math.round(value / 1000000) * 1000000;
  }
}

// 値に応じた刻み幅を計算する関数
export function getStep(value: number): number {
  if (value < 10000) return 1000;
  if (value < 100000) return 10000;
  if (value < 1000000) return 100000;
  return 1000000;
} 